import { render, staticRenderFns } from "./ebookStatis.vue?vue&type=template&id=21f0bc4b&scoped=true"
import script from "./ebookStatis.vue?vue&type=script&lang=js"
export * from "./ebookStatis.vue?vue&type=script&lang=js"
import style0 from "./ebookStatis.vue?vue&type=style&index=0&id=21f0bc4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f0bc4b",
  null
  
)

export default component.exports